/* import __COLOCATED_TEMPLATE__ from './sales-agent-state.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { AiContentState } from 'embercom/lib/ai-content-library/constants';
import { type FolderCounts } from 'embercom/lib/content-service/search-api';

interface SalesAgentStateSignature {
  Args: {
    salesAgentStates: AiContentState[];
    fingested?: boolean;
    folderCounts?: FolderCounts;
  };
}

export default class SalesAgentState extends Component<SalesAgentStateSignature> {
  stateWhenUsed = AiContentState.USED_BY_FIN;

  get hasStates(): boolean {
    return this.args.salesAgentStates && this.args.salesAgentStates.length > 0;
  }

  // returning true since there isn't any pre-condition for success state
  get preCondition(): boolean {
    return true;
  }

  get isIngesting(): boolean {
    return this.args.salesAgentStates.length === 1 &&
      this.args.salesAgentStates[0] === this.stateWhenUsed &&
      this.args.fingested !== undefined
      ? !this.args.fingested
      : false;
  }

  get hasFolderCounts(): boolean {
    return !!this.args.folderCounts;
  }

  get salesAgentEnabledCount(): number {
    return this.args.folderCounts?.sales_agent_enabled ?? 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::SalesAgentState': typeof SalesAgentState;
    'knowledge-hub/filterable-list/table/cells/sales-agent-state': typeof SalesAgentState;
  }
}
